
import { controls } from '../../controls';

const ms207 = {
  label: "CC Renewal Entry",
  pageLabel: "CC Renewal Entry",
  starting: true,
  url: "ms207",
  pageType: "history",
  form: [
    {
      widths: "col-sm-12",
      subComponents: [
        ...controls.displayText({ label: "Parent Branch", star: true, width: "col-sm-2" }),
        ...controls.branch({ defaultValue: "assigned_branch", isRequired: true }),
        ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-2" }),

        ...controls.displayText({ star: true, label: "GL Sub Head", width: "col-sm-2" }),
        ...controls.product({ isRequired: true, width: "col-sm-2" }),
        ...controls.showData({ width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),

        ...controls.displayText({ star: true, label: "Account No", width: "col-sm-2" }),

        ...controls.AccountNumber({
          isRequired: true, beforeLeave: ["createAcNo"], displayData: { descn: "account_number_display", guid: 'account_number_guid', interest_flag: 'interest_flag', IntRecdGL: 'IntRecdGL', min_advance: "min_advance", min_advance_date: "min_advance_date", max_advance: "max_advance", max_advance_date: "max_advance_date", receipts: "receipts", payments: "payments", avg_balance: "avg_balance", interest_debited: "interest_debited", sanction_amount: "old_sanction_amount", opening_date: "opening_date", product_code_display: "product_code_display", product_code_guid: "product_code_guid", product_code: "product_code", interest_rate: "interest_rate", gl_guid: "gl_guid" }
        }),
        ...controls.showData({ data: "account_number_display", width: "col-sm-2" }),
      ]
    },
    {
      widths: "col-sm-12",
      widths: "col-sm-12",
      title: "Renewal Information",
      subComponents: [
        ...controls.displayText({ label: "Min Advance", width: "col-sm-2" }),
        ...controls.showData({ data: "min_advance", displaytype: "currency" }),
        ...controls.displayText({ label: "Max Advance", width: "col-sm-2" }),
        ...controls.showData({ data: "max_advance", displaytype: "currency" }),
        ...controls.displayText({ label: "Receipts", width: "col-sm-2" }),
        ...controls.showData({ data: "receipts", displaytype: "currency" }),

        ...controls.magicDateLabel({ star: true, label: "Min Advance Date", width: "col-sm-2" }),
        ...controls.showData({ data: "min_advance_date", displaytype: "date" }),
        ...controls.magicDateLabel({ star: true, label: "Max Advance Date", width: "col-sm-2" }),
        ...controls.showData({ data: "max_advance_date", displaytype: "date" }),
        ...controls.displayText({ label: "Payments", width: "col-sm-2" }),
        ...controls.showData({ data: "payments", displaytype: "currency" }),

        ...controls.displayText({ label: "Avg Balance", width: "col-sm-2" }),
        ...controls.showData({ data: "avg_balance", displaytype: "currency" }),
        ...controls.displayText({ label: "Interest Debited", width: "col-sm-2" }),
        ...controls.showData({ data: "interest_debited", displaytype: "currency" }),
      ]
    },
    {
      widths: "col-sm-12",
      subComponents: [

        ...controls.displayText({ star: true, label: "Sanction Letter Number", width: "col-sm-2" }),
        ...controls.numberOnly({ isRequired: true, placeHolder: "Sanction Letter Number", width: "col-sm-2", name: "sanction_letter_number" }),
        ...controls.magicDateLabel({ star: true, label: "Sanction Date", width: "col-sm-2" }),
        ...controls.magicDate({ isRequired: true, dateType: "ontype", name: "sanction_date", width: "col-sm-2" }),

        ...controls.magicDateLabel({ star: true, label: "Account Opening Date", width: "col-sm-2" }),
        ...controls.showData({ data: "opening_date", displaytype: "date" }),

        ...controls.displayText({ star: true, label: "Old Saction Amount", width: "col-sm-2" }),
        ...controls.showData({ data: "old_sanction_amount", displaytype: "currency" }),
        ...controls.displayText({ star: true, label: "New Saction Amount", width: "col-sm-2" }),
        ...controls.numberOnly({ isRequired: true, name: "sanction_amount", width: "col-sm-2" }),
        ...controls.displayText({ label: "", width: "col-sm-4" }),

        ...controls.displayText({ star: true, label: "Period in Months", width: "col-sm-2" }),
        ...controls.numberOnly({
          isRequired: true, placeHolder: "Period", name: "period", width: "col-sm-2",
          onRender: [
            // // sum last column of the current table
            { f: 'dateArithmatic', calcType: 'sum', inputs: [{ source: 'pageData.sanction_date', field: 'sanction_date', type: "date" }, { source: 'pageData.period', field: "period", type: "months" }], resultVar: 'futureDate' },
            // // and set it as some other parentState.
            { f: 'setParentState', inputs: { dest: "pageData.maturity_date", source: 'allResults', field: 'futureDate' }, resultVar: "maturity_date" },
          ]
        }),

        ...controls.magicDateLabel({ star: true, isReadOnly: true, label: "Maturity Date", width: "col-sm-2" }),
        ...controls.showData({ isRequired: true, data: "maturity_date", displaytype: "date" }),

        ...controls.displayText({ star: true, label: "Interest Rate", width: "col-sm-2" }),
        ...controls.showData({ isRequired: true, data: "interest_rate", displaytype: "currency" }),
      ]
    },
  ]
};

export default ms207;
